<script>
export default {
  props: {
    title: {
      default: undefined,
      type: String,
    },
    headingTag: {
      default: 'h2',
      type: String,
    },
    category: {
      default: null,
      type: String,
    },
    content: {
      default: undefined,
      type: String,
    },
    imgSrc: {
      default: null,
      type: String,
    },
    createdAt: {
      default: undefined,
      type: String,
    },
    url: {
      default: '#!',
      type: [String, Number],
    },
    boldCategory: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    toSingle: function(url) {
      this.$router.push({ path: url })
    },
  },
}
</script>

<template>
  <div class="card my-3 text-left p-2 w-100" :class="$style.dataCenterCard">
    <div class="card-body">
      <span v-if="category" :class="[$style.boldCategory]">{{ category }}</span>
      <div :class="imgSrc !== null ? $style.content : ''">
        <img v-if="imgSrc" v-lazy="imgSrc" :alt="title" />
        <div>
          <router-link
            v-if="headingTag === 'a'"
            :to="url"
            :class="[$style.headingTitle, $style.normalHeading]"
          >
            {{ title }}
          </router-link>
          <component
            :is="headingTag"
            v-else
            :class="$style.headingTitle"
            @click="toSingle(url)"
          >
            {{ title }}
          </component>
          <slot />
        </div>
      </div>
      <hr v-if="createdAt" />
      <span v-if="createdAt">{{ createdAt }}</span>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.dataCenterCard {
  border: 1px solid $gray;
  border-radius: $radius;
  .boldCategory {
    font-weight: bold;
    color: $dark;
  }
  .headingTitle {
    // font-size: 1.9rem;
    font-weight: $medium;
    line-height: 1.5;
    color: $primary;
    cursor: pointer;
    &.normalHeading {
      display: block;
      font-size: 1.25rem;
      text-decoration: none;
    }
  }
  .content {
    display: flex;
    align-items: center;
    margin: 1rem 0;
    img {
      width: 8rem;
      height: 8rem;
      margin-right: 2rem;
      object-fit: cover;
    }
  }
  hr {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
}
@media only screen and (max-width: $mobile-sm) {
  .dataCenterCard {
    .headingTitle {
      line-height: 1;
    }
  }
}
</style>
